export default __webpack_public_path__ + "static/media/05.f57a730d.png";